
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live-cams",
      function () {
        return require("private-next-pages/live-cams.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live-cams"])
      });
    }
  